import React, { useEffect, useRef, useState } from 'react';
import { ZdsTextarea } from '@zig-design-system/ui-components-react';
import { Label } from './elements/Label';
import { validate } from '../../utilitity/validation';
import { Validation } from './elements/Validation';
export const Textarea = ({ field, onChange, value: defaultValue }) => {
    var _a;
    const [value, setValue] = useState((_a = defaultValue) !== null && _a !== void 0 ? _a : '');
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const validation = validate(field.validation);
        const fieldValidation = (event) => {
            event.detail.validationState = validation(event.detail.value);
        };
        if (validation) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('zdsValidate', fieldValidation);
        }
        return () => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('zdsValidate', fieldValidation);
        };
    }, []);
    const handleChange = (e) => {
        setValue(e.target.value);
        onChange(field, e.target.value);
    };
    return (React.createElement(ZdsTextarea, { rows: 5, id: `powermail_field_${field.marker}`, readonly: field.readonly, placeholder: field.placeholder, onZdsChange: handleChange, required: field.mandatory, maxlength: field.maxLength, value: value, ref: ref },
        React.createElement(Label, { field: field }),
        React.createElement(Validation, { field: field })));
};
